import { CANDIDATO_TOKEN_KEY, LOGO_DEFENSORIA_SRC } from './candidato.constants';
import { CandidatoAuthService } from './candidato-auth.service';
import { isValidCPF, validaCPF } from '@/shared/utils/cpfs';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function LoginCandidatoPage() {
  const [cpf, setCpf] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tokenEnviado, setTokenEnviado] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const candidatoAuthService = new CandidatoAuthService();

  useEffect(() => {

    const tokenFromUrl = searchParams.get('token');
    if (tokenFromUrl) {
      candidatoAuthService.validarToken(tokenFromUrl)
        .then((result) => {
          if (result.valid) {
            localStorage.setItem(CANDIDATO_TOKEN_KEY, tokenFromUrl);
            navigate('/candidato/meus-processos');
          } else {
            toast.error('Token inválido ou expirado. Solicite um novo acesso.');
          }
        })
        .catch(() => {
          toast.error('Erro ao validar token. Tente novamente.');
        });
    }

    const token = localStorage.getItem(CANDIDATO_TOKEN_KEY);
    if (token) {
      candidatoAuthService.validarToken(token)
        .then((result) => {
          if (result.valid) {
            navigate('/candidato/meus-processos');
          } else {
            localStorage.removeItem(CANDIDATO_TOKEN_KEY);
          }
        })
        .catch(() => {
          localStorage.removeItem(CANDIDATO_TOKEN_KEY);
        });
    }
  }, [searchParams, navigate]);

  const handleSolicitarToken = async (e: React.FormEvent) => {
    e.preventDefault();

    const cpfLimpo = cpf.replace(/\D/g, '');

    if (!cpfLimpo || cpfLimpo.length !== 11) {
      toast.error('Por favor, informe um CPF com 11 dígitos.');
      return;
    }

    setIsLoading(true);
    try {
      await candidatoAuthService.solicitarTokenPorCPF(cpfLimpo);
      setTokenEnviado(true);
      toast.success('Link de acesso enviado por email. Verifique sua caixa de entrada e spam.');
    } catch (error: any) {

      const errorMessage = error?.response?.data?.message || error?.message || '';
      if (errorMessage.includes('não está cadastrado em nenhum processo seletivo') ||
        errorMessage.includes('não está cadastrado')) {
        toast.error('Este CPF não está cadastrado em nenhum processo seletivo.');
      } else if (error?.response?.status === 400) {
        toast.error(errorMessage || 'Erro ao solicitar acesso. Verifique o CPF informado.');
      } else {
        toast.error('Erro ao solicitar acesso. Tente novamente mais tarde.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body p-3">
              <div className="card-body text-center p-1 mb-2">
                <img style={{ width: '150px', height: '150px' }} src={LOGO_DEFENSORIA_SRC} alt="Logo Defensoria" className="img-fluid" />
              </div>
              <div className="text-center mb-4">
                <h2 className="card-title">Portal do Candidato</h2>
                <p className="text-muted">Acesse seus processos seletivos</p>
              </div>

              {tokenEnviado ? (
                <div className="alert alert-success">
                  <h5 className="alert-heading">Token solicitado!</h5>
                  <p>
                    Se o CPF <strong>{cpf}</strong> estiver cadastrado em nosso sistema,
                    você receberá um link de acesso por email em breve.
                  </p>
                  <p className="mb-0">
                    Verifique sua caixa de entrada e spam.
                  </p>
                  <button
                    className="btn btn-link p-0 mt-2"
                    onClick={() => {
                      setTokenEnviado(false);
                      setCpf('');
                    }}
                  >
                    Solicitar novo acesso
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSolicitarToken}>
                  <div className="mb-3">
                    <label htmlFor="cpf" className="form-label">
                      CPF utilizado na candidatura
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cpf"
                      value={cpf}
                      onChange={(e) => {

                        const valor = e.target.value;
                        const valorLimpo = valor.replace(/[^\d.-]/g, '');

                        if (valorLimpo.length <= 14) {
                          setCpf(validaCPF(valorLimpo, true));
                        }
                      }}
                      onBlur={(e) => {

                        const cpfLimpo = e.target.value.replace(/\D/g, '');
                        if (cpfLimpo.length === 11 && !isValidCPF(cpfLimpo)) {
                          // Se o CPF completo não for válido, manter formatado mas mostrar aviso
                          // Não limpar o campo para não frustrar o usuário
                        }
                      }}
                      placeholder="000.000.000-00"
                      minLength={11}
                      maxLength={14}
                      required
                      disabled={isLoading}
                    />
                    <small className="form-text text-muted">
                      Informe o mesmo CPF que você utilizou ao se candidatar
                    </small>
                  </div>

                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Enviando...' : 'Solicitar Acesso'}
                    </button>
                  </div>
                </form>
              )}

              <div className="mt-4 text-center">
                <small className="text-muted">
                  Você receberá um link por email (cadastrado na candidatura) para acessar seus processos seletivos.
                  <br />
                  O link é válido por 30 dias.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

